export default __webpack_public_path__ + "static/insta0-3f9a113ca612bbe1ddec80ca30daa8aa.png";